module.exports = __webpack_public_path__ + "static/img/ent-detail-79.7e0eb0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-79.jpg
// module id = ybxv
// module chunks = 52